<template>
    <div>
        <el-form ref='ruleForm' :model="rulesform" label-width="20px" class="event-form">
            <el-row :gutter="20">
                <el-col :span="8">
                    <p class="textC">From</p>
                    <el-form-item>
                        <el-button type="primary" @click="configEvent('fromRelevancyConfig')" v-if="rulesform.fromApp.length == 0">配置项</el-button>
                        <!-- <router-link :to="{ path: '/relevancyConfig',query:{callback:fromRelevancyConfig}}">
                            <el-button type="primary">配置项</el-button>
                        </router-link> -->
                        <relevancy-tab :data="rulesform.fromSerialNumber" :getData="getFromCmdbData"></relevancy-tab>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="appEvent('fromRelevancyApp')" v-if="rulesform.fromSerialNumber.length == 0">应用</el-button>
                        <!-- <router-link :to="{ path: '/relevancyApp',query:{callback:fromRelevancyApp}}">
                            <el-button type="primary">应用</el-button>
                        </router-link> -->
                        <relevancyTabAPP :data="rulesform.fromApp" :getData="getFromAppData"></relevancyTabAPP>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <!-- <div class="grid-content bg-purple"></div> -->
                    <!-- label="配置项CI的关系类型:" -->
                    <p class="textC">关系类型</p>
                    <el-form-item >
                        <el-select v-model="rulesform.relation_type" placeholder="请选择">
                            <el-option
                             v-for="item in cmdbRelationshipType"
                             :key="item.id"
                             :label="item.cname"
                             :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <p class="textC">备注</p>
                    <el-form-item>
                        <el-input v-model="rulesform.description" type='textarea'></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <p class="textC">To</p>
                    <el-form-item>
                        <el-button type="primary" @click="configEvent('toRelevancyConfig')" v-if="rulesform.toApp.length == 0">配置项</el-button>
                        <!-- <router-link :to="{ path: '/relevancyConfig',query:{callback:toRelevancyConfig}}">
                            <el-button type="primary">配置项</el-button>
                        </router-link> -->
                        <relevancy-tab :data="rulesform.toSerialNumber" :getData="getToCmdbData"></relevancy-tab>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary"  @click="appEvent('toRelevancyApp')" v-if="rulesform.toSerialNumber.length == 0">应用</el-button>
                        <!-- <router-link :to="{ path: '/relevancyApp',query:{callback:toRelevancyApp}}">
                            <el-button type="primary">应用</el-button>
                        </router-link> -->
                        <relevancyTabAPP :data="rulesform.toApp" :getData="getToAppData"></relevancyTabAPP>
                    </el-form-item>
                </el-col>
            </el-row>




           <!--   -->
            <el-form-item>
                <el-button type='primary' @click='submitForm("ruleForm")' :disabled="isSubmit">确定</el-button>
                <el-button type='primary' @click='ResetForm("ruleForm")'>重置</el-button>
            </el-form-item>
        </el-form>

        <!--&lt;!&ndash; 内弹框 &ndash;&gt;-->
        <!--<el-dialog title="添加配置项关系" :visible.sync="innerVisible" append-to-body>-->
            <!--<div>-->
                <!--<add-configuration :getServes='suremit' ></add-configuration>-->
                <!--&lt;!&ndash;<el-button type="primary" @click="suremit">确 ?定</el-button>&ndash;&gt;-->
            <!--</div>-->
        <!--</el-dialog>-->

    </div>
</template>

<script>
import services from '../configuration.services'
import relevancyTab from "../../common/relevancyTab.vue"
import relevancyTabAPP from '../relevancyTabAPP'

import addConfiguration from '../../../components/addConfiguration'
export default {

    components: { addConfiguration,relevancyTab ,relevancyTabAPP},

    props: {
        serialNumber: String | Number,
        callback: Function
    },

    data() {
        return {
            rulesform: {
                serialNumber: this.serialNumber,
                fromSerialNumber:[],
                fromApp:[],
                toSerialNumber: [],
                toApp:[],
                relation_type: '377',
                description: ''
            },
            toAppName:[],
            toAppId:[],
            toConfigName:[],
            source_node_sn:[],
            target_node_sn:[],
            // innerVisible: false,
            getData: [],
            isSubmit:false
        }
    },

    computed: {

        // 数据字典
        dictionary() {
            return this.$store.state.dictionary
        },

        // 配置项CI的关系类型
        cmdbRelationshipType() {
            return this.dictionary.cmdb_relationship_type
        }
    },

    methods: {
        //配置项按钮
        configEvent(eventStr){
            let configradioFlag = false
            if(eventStr == 'fromRelevancyConfig'){
                // console.log('配置按钮---from')
                // console.log(this.rulesform.toSerialNumber)
                // console.log(this.rulesform.toApp)
                if(this.rulesform.toSerialNumber.length >1 || this.rulesform.toApp.length >1){
                    configradioFlag = true
                }
            }else{
                // console.log('配置按钮---to')
                if(this.rulesform.fromSerialNumber.length >1 || this.rulesform.fromApp.length >1){
                    configradioFlag = true
                }
                // console.log(this.rulesform.fromSerialNumber)
                // console.log(this.rulesform.fromApp)
            }
            // console.log(configradioFlag)
            this.$router.push({
                path:'/relevancyConfig',
                query:{radioCheck:configradioFlag, callback:this[eventStr] }
            })
        },
        //应用按钮
        appEvent(eventStr){
            // console.log(this[eventStr])
            let radioFlag = false
            if(eventStr == 'fromRelevancyApp'){
                // console.log('应用按钮---from')
                if(this.rulesform.toSerialNumber.length >1 || this.rulesform.toApp.length >1){
                    radioFlag = true
                }
                // console.log(this.rulesform.toSerialNumber)
                // console.log(this.rulesform.toApp)
            }else{
                // console.log('应用按钮---to')
                if(this.rulesform.fromSerialNumber.length >1 || this.rulesform.fromApp.length >1){
                    radioFlag = true
                }
                // console.log(this.rulesform.fromSerialNumber)
                // console.log(this.rulesform.fromApp)
            }
            // console.log(radioFlag)
            this.$router.push({
                path:'/relevancyApp',
                query:{radioCheck:radioFlag, callback:this[eventStr] }
            })
        },
        // 确认按钮
        submitForm(formName) {
            this.isSubmit=true
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // this.rulesform.targetSerialNumber = this.getData.map(item => item.serialNumber)
                    // this.rulesform.toSerialNumber=[].concat(this.toConfigId,this.toAppId)
                    // this.rulesform.toApp=this.toAppId
                    let params={
                        topology_id: this.serialNumber,
                        source_node_sn: this.source_node_sn,
                        target_node_sn: this.target_node_sn,
                        relation_type: this.rulesform.relation_type,
                        description: this.rulesform.description,
                    }
                    // console.log(params)
                    services.topologyRelationAdd(params)
                        .then(res => this.$message.success('添加成功'))
                        .catch(err => {
                            this.isSubmit=false
                            this.$message.error(err.message)
                        })
                        .finally(() => {
                            this.$modal.close();
                            this.callback();
                        })
                }else{
                    this.isSubmit=false
                    this.$message.error('✳为必填项，请全部填写')
                }
            });
        },

        // 重置  targetSerialNumber
        ResetForm(formName) {
            this.rulesform = {
                serialNumber: this.serialNumber,
                fromSerialNumber:[],
                fromApp:[],
                toSerialNumber: [],
                toApp:[],
                relation_type: '377',
                description: ''
            }
        },
        //获取选择后的关联的配置项
        fromRelevancyConfig(val){
            console.log(val)
            // this.rulesform.fromSerialNumber=this.rulesform.fromSerialNumber.concat(val)
            this.rulesform.fromSerialNumber=val
            val.forEach(item => {
                // this.toConfigName.push(item.title);
                // this.source_node_sn = item.serialNumber
                this.source_node_sn.push(item.serialNumber)
                // this.toConfigId.push(item.serialNumber);
            });
        },
        toRelevancyConfig(val){
            this.rulesform.toSerialNumber=val
            val.forEach(item => {
                // this.toConfigName.push(item.title);
                // this.toConfigId.push(item.serialNumber);
                // this.target_node_sn = item.serialNumber
                this.target_node_sn.push(item.serialNumber)
            });
        },
        //获取选择后的关联的应用
        fromRelevancyApp(val){
            this.rulesform.fromApp=this.rulesform.fromApp.concat(val)
            val.forEach(item => {
                // this.source_node_sn = item.id.toString()
                this.source_node_sn.push(item.id.toString())
                // this.toAppName.push(item.name);
                // this.toAppId.push(item.id.toString());
            });
        },
        toRelevancyApp(val){
            this.rulesform.toApp=this.rulesform.toApp.concat(val)
            val.forEach(item => {
                // this.toAppName.push(item.name);
                // this.toAppId.push(item.id.toString());
                this.target_node_sn.push(item.id.toString())
                // this.target_node_sn = item.id.toString()
            });
        },
        getFromCmdbData(val){
            // console.log(val)
            this.rulesform.fromSerialNumber  = val;
        },
        getToCmdbData(val){ this.rulesform.toSerialNumber  = val;},
        getFromAppData(val){ this.rulesform.fromApp  = val;},
        getToAppData(val){ this.rulesform.toApp  = val;},
        suremit(nodes) {
            this.getData = nodes
            this.rulesform.toSerialNumber = this.getData.map(item => item.title).join()
            this.innerVisible = false
        }

    }
}
</script>

<style scoped>
    .targetSerialNumberBox {
        width: 200px;
        height: 28px;
        border: 1px solid #C0C4CC;
        border-radius: 4px;
        overflow: hidden;
    }
    .textC{
        text-align: center;
    }
</style>
